import React, { useState, useEffect } from "react";
import {
  RightOutlined,
  CalendarOutlined,
  CaretDownOutlined,
  FieldTimeOutlined,
  LoadingOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { Flex, Typography, Spin } from "antd";
import { Button } from "@voicecare.ai/ui-library";
import "./callAutomationInfo.css";
import { Colors } from "../callhistory/helpers";
import { useTheme } from "../../ThemeContext";
import * as XLSX from "xlsx";

const { Text } = Typography;

function convertTo12HourFormat(time24) {
  const [hours, minutes, seconds = "00"] = time24.split(":");
  let period = "AM";

  let hour = parseInt(hours, 10);
  let formattedHour = hour;

  if (hour >= 12) {
    period = "PM";
    if (hour > 12) {
      formattedHour = hour - 12;
    }
  }

  formattedHour = String(formattedHour).padStart(2, "0"); // Add leading zero if needed

  return `${formattedHour}:${minutes} ${period}`;
}

const selectedDateRange = (input = {}) => {
  const dates = [];
  for (let i = 0; i < input["startDates"]?.length; i++) {
    const formattedStartDate = input["startDates"][i].split("-").join("/");
    const formattedEndDate = input["endDates"][i].split("-").join("/");
    const dateRange = `${formattedStartDate} to ${formattedEndDate}`;
    dates.push(dateRange);
  }
  return dates;
};

export const DataValidationOverlay = ({
  batchId,
  open,
  loading,
  success,
  failed,
  children,
  closeOverlay,
  csvData,
  errorList,
  setErrorOpen,
  message,
}) => {
  function formatDate() {
    const date = new Date();

    const pad = (num) => num.toString().padStart(2, "0");

    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  }

  // const downloadCSV = (response) => {
  //   console.log(response, "downloadCSV")
  //   // Create a Blob from the response data
  //   const blob = new Blob([response], { type: "text/csv" });
  //   const url = window.URL.createObjectURL(blob);

  //   // Create a link element and simulate a click to trigger the download
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = `ERROR-${formatDate(new Date())}-${batchId}.csv`;
  //   document.body.appendChild(a);
  //   a.click();

  //   // Cleanup
  //   window.URL.revokeObjectURL(url);
  //   document.body.removeChild(a);
  // };

  const downloadCSV = (response) => {
    console.log(response, "downloadCSV");
  
    // Access the csv_data property
    const csvData = response.csv_data;
  
    // Create a Blob from the csvData
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
  
    // Create a link element and simulate a click to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = `ERROR-${formatDate(new Date())}-${batchId}.csv`;
    document.body.appendChild(a);
    a.click();
  
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const handleDownload = () => {
    downloadCSV(errorList);
    setTimeout(() => {
      closeOverlay();
    }, [3000]);
  };

  const { themeMode } = useTheme();
  const renderOverlay = () => {
    const getData = () => {
      const item = sessionStorage.getItem("insufficient_storage_error");
      if (item !== "{}") {
        return JSON.parse(item);
      }
      return { recommended_date: "", recommended_time: "" };
    };

    const isDataReady = () => {
      console.log(
        "lllop",
        sessionStorage.getItem("insufficient_storage_error")
      );
      return JSON.parse(
        sessionStorage.getItem("insufficient_storage_error").includes("date")
      );
    };
    return (
      <Flex
        style={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          top: 0,
          bottom: 0,
          left: "2.5vh",
          inset: "0px 0px 0px 10px",
          right: 0,
          height: "84vh",
          backgroundColor:
            themeMode === "dark"
              ? "rgba(18, 30, 78, 0.97)"
              : "rgb(250,249,251, 0.90)",
          color: themeMode === "dark" ? "white" : "black",
          zIndex: 1000,
          border: "100px solid",
        }}
      >
        {loading && (
          <img
            className="loader"
            src={
              themeMode === "dark"
                ? "/icons/loader_white.gif"
                : "/icons/loader_black.gif"
            }
          />
        )}
        {message && !loading && (
          <Flex vertical gap={10} justify="center" align="center">
            <div style={{
              color: '#4caf50',
              fontWeight: 600,
              fontSize: 22,
              marginBottom: 24,
              textAlign: 'center',
              whiteSpace: 'pre-line',
              padding: '0 24px'
            }}>{message}</div>
            <Button
              style={{
                border: "none",
                outline: "none",
                paddingLeft: 32,
                paddingRight: 32,
                margin: "auto",
                background: Colors.orange,
                color: Colors.text,
                borderRadius: 4,
              }}
              label="Return Home"
              onClick={() => closeOverlay()}
            />
          </Flex>
        )}
        {failed && (
          <Flex vertical gap={10} justify="center" align="center">
            <Text
              style={{
                fontSize: 19,
                color: themeMode === "dark" ? Colors.text : "black",
              }}
            >
              Data Not Uploaded to Database. Please try again.
            </Text>
         
          </Flex>
        )}
      </Flex>
    );
  };
  return (
    <Flex vertical style={{ width: "100%", position: "relative" }}>
      {open && renderOverlay()}
      {children}
    </Flex>
  );
};

export const SelectedDates = ({ selectedDate }) => {
  const { themeMode } = useTheme();
  return (
    <div
      className={`${themeMode}-call-automation-selected-dates-wrapper`}
      style={{ zIndex: 999 }}
    >
      <Flex
        justify="center"
        align="center"
        gap={10}
        style={{
          marginLeft: 10,
          userSelect: "none",
          backgroundColor: "inherit",
          zIndex: 900,
        }}
      >
        <CalendarOutlined
          style={{
            color: Colors.orange,
            fontSize: 17,
          }}
        />
        <Text style={{ color: Colors.orange }}>
          {selectedDate ? formatDate(selectedDate) : "No date selected"}
        </Text>
      </Flex>
    </div>
  );
};

const SelectedTime = ({ startTime }) => {
  return (
    <Flex style={{ marginLeft: 20 }}>
      <img src="icons/clock.svg" style={{ width: "2vh", marginRight: "1vh" }} />
      <Text style={{ color: Colors.textLight, fontSize: 17 }}>
        {startTime ? convertTo12HourFormat(startTime) : "--:--"}
      </Text>
    </Flex>
  );
};

const formatDate = (date) => {
  if (!date) return null;
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${mm}/${dd}/${year}`;
};

const formatTime = (time) => {
  if (!time) return null;
  try {
    // Handle format: MM-DD-YYYY_HH:mm:ss
    if (time.includes('_')) {
      const timePart = time.split('_')[1];
      const [hourStr, minuteStr] = timePart.split(':');
      const hour = parseInt(hourStr, 10);
      const minute = parseInt(minuteStr, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minuteStr} ${ampm}`;
    }
    // Fallback: previous logic
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12} ${ampm}`;
  } catch (error) {
    console.error("Error formatting time:", error);
    return null;
  }
};

export const CallAutomationInfo = ({
  selectedDate,
  handleValidate,
  handleSubmit,
  selectedTime,
  handleBack,
  handleAdd,
  handleDelete,
  loading,
  selectedQuestions,
  onShowQuestions,
  errorCellCount,
  onSchedule,
  selectedSlotDisplayTime,
  needsValidation,
  selectedRowIdx,
  isTrialUser = false,
  canAddPatient = null,
  filteredTableData,
  // NEW: number of selected rows for multi-delete UX
  selectedRowCount = 0,
}) => {
  const { currentTheme, themeMode } = useTheme();
  const [canAddMorePatients, setCanAddMorePatients] = useState(true);
  
  // Check if trial user can add patients when component mounts or data changes
  useEffect(() => {
    const checkAddPatientStatus = async () => {
      if (isTrialUser && canAddPatient) {
        const canAdd = await canAddPatient();
        setCanAddMorePatients(canAdd);
        console.log(`🔍 TRIAL DEBUG: Add Patient button status - canAdd: ${canAdd}`);
      } else {
        setCanAddMorePatients(true);
      }
    };
    
    checkAddPatientStatus();
  }, [isTrialUser, canAddPatient, filteredTableData]);

  const formatDisplayDate = (date) => {
    if (!date) return "No date selected";
    try {
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid date";
    }
  };

  const formatTime = (time) => {
    if (!time) return null;
    try {
      // Handle format: MM-DD-YYYY_HH:mm:ss
      if (time.includes('_')) {
        const timePart = time.split('_')[1];
        const [hourStr, minuteStr] = timePart.split(':');
        const hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minuteStr} ${ampm}`;
      }
      // Fallback: previous logic
      const [hours, minutes] = time.split(":");
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;
      return `${hour12} ${ampm}`;
    } catch (error) {
      console.error("Error formatting time:", error);
      return null;
    }
  };

  return (
    <div
      style={{ margin: "12px auto", width: "100%", boxSizing: "border-box" }}
    >
      <Flex justify="start" align="center">
        
        <CalendarOutlined
          style={{
            color: Colors.orange,
            fontSize: 17,
            marginRight: 5,
          }}
        />
        <Text style={{ color: Colors.orange, marginRight: 20 }}>
          {formatDisplayDate(selectedDate)}
        </Text>
        <ClockCircleOutlined
          style={{
            color: Colors.orange,
            fontSize: 17,
            marginRight: 5,
          }}
        />
        <Text style={{ color: Colors.orange }}>
          {selectedSlotDisplayTime
            ? selectedSlotDisplayTime
            : (formatTime(selectedTime) || "--:-- --")}
        </Text>
        <div style={{ marginLeft: "auto", display: "flex", gap: "1vh", alignItems: "center" }}>
          <Button
            onClick={onShowQuestions}
            style={{ borderRadius: "1vh", width: "8rem", backgroundColor: Colors.orange }}
            label={`Custom Questions (${selectedQuestions?.length || 0})`}
            className="validate-button"
          />
          <Button
            onClick={handleAdd}
            disabled={isTrialUser && !canAddMorePatients}
            style={{ 
              borderRadius: "1vh", 
              width: "8rem", 
              backgroundColor: (isTrialUser && !canAddMorePatients) ? '#ccc' : Colors.orange,
              opacity: (isTrialUser && !canAddMorePatients) ? 0.6 : 1,
              cursor: (isTrialUser && !canAddMorePatients) ? 'not-allowed' : 'pointer'
            }}
            label={isTrialUser && !canAddMorePatients ? "Limit Reached" : "Add Patient"}
            className="validate-button"
          />
          <Button
            onClick={handleDelete}
            style={{ 
              borderRadius: "1vh", 
              width: "8rem", 
            }}
            label={
              selectedRowCount === 0
                ? "Select Rows to Delete"
                : selectedRowCount === 1
                  ? "Delete Patient"
                  : `Delete ${selectedRowCount} Patients`
            }
            className="validate-button"
            disabled={selectedRowCount === 0}
          />
          <Button
            onClick={handleBack}
            style={{ borderRadius: "1vh", width: "8rem", backgroundColor: Colors.orange }}
            label="Back"
            className="validate-button"
          />
          {needsValidation ? (
            <Button
              onClick={handleValidate}
              style={{ borderRadius: "1vh", width: "8rem", backgroundColor: Colors.orange }}
              label="Validate"
              className="validate-button"
              disabled={loading}
            />
          ) : (
            <Button
              onClick={onSchedule}
              style={{ borderRadius: "1vh", width: "8rem", backgroundColor: Colors.orange }}
              label="Submit"
              className="validate-button"
              disabled={errorCellCount > 0 || loading || !selectedDate || !selectedTime}
            />
          )}
        </div>
      </Flex>
      {loading && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <img
            className="loader"
            src={themeMode === "dark" ? "/icons/loader_white.gif" : "/icons/loader_black.gif"}
            alt="Loading..."
          />
        </div>
      )}
    </div>
  );
};